<template>
    <div>

        <section class=" base-header-sec-2 base-header-laen  laen">
            <!--            <div class="base-header__top-line laen"></div>-->
            <div class="container-fluid">

                <div class=" container-lg  base-header__container ">
                    <div class="inner ml-lg-5 d-flex justify-content-between align-items-center">
                        <ul class="nav ">
                            <li class="nav-itembase-sub-page-link ">
                                <router-link class="nav-link  " to="/supa-advancedSearch-ccSearch">
                                    Уставни суд
                                </router-link>
                            </li>
                            <li class="nav-item base-sub-page-link">
                                <router-link class="nav-link" to="/supa-advancedSearch-ocSearch">
                                    Остали судови
                                </router-link>
                            </li>

                            <li class="nav-item base-sub-page-link">
                                <router-link class="nav-link " to="/supa-advancedSearch-fcSearch">
                                    Страна судска пракса
                                </router-link>
                            </li>
                            <li class="nav-item base-sub-page-link">
                                <router-link class="nav-link " to="/supa-advancedSearch-biltenSearch">
                                    Билтени
                                </router-link>
                            </li>

                        </ul>

                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "SupaAdvancedSearchBaseHeaderSec"
    }
</script>

<style scoped>

</style>
